import { useClassName } from '@/styles/CoverBox';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';
import { CoverBoxBodyComponent } from './CoverBox.Body';
import { CoverBoxExpandComponent } from './CoverBox.Expand';
import { CoverBoxGroupComponent } from './CoverBox.Group';
import { CoverBoxHeadlineComponent } from './CoverBox.Headline';
import { CoverBoxIconComponent } from './CoverBox.Icon';
import { CoverBoxImagesComponent } from './CoverBox.Images';

export type CoverBoxProps = ComponentProps<'section'>;

const CoverBoxComponent: Component<CoverBoxProps> = ({ children, ...props }) => {
  const className = useClassName('', props);

  return <section {...mergeProps({ className }, props)}>{children}</section>;
};

export const CoverBox = Object.assign(CoverBoxComponent, {
  Images: CoverBoxImagesComponent,
  Group: CoverBoxGroupComponent,
  Headline: CoverBoxHeadlineComponent,
  Icon: CoverBoxIconComponent,
  Body: CoverBoxBodyComponent,
  Expand: CoverBoxExpandComponent,
});
